export const COLOR_SWATCHES_BREAKPOINTS = {
  MOBILE_MAX: 767,
  TABLET_MIN: 768,
  TABLET_MAX: 1023,
  DESKTOP_MIN: 1024,
};
export const EXPANDABLE_THRESHOLDS = {
  DESKTOP: {
    COLOR: 15,
    IMAGE: 9,
  },
  TABLET: {
    COLOR: 29,
    IMAGE: 21,
  },
  MOBILE: {
    COLOR: 15,
    IMAGE: 13,
  },
};

/**
 * @param {number} screenWidth
 * @returns {string}
 */
export const getDeviceType = (screenWidth = typeof window !== 'undefined' ? window.innerWidth : 1024) => {
  if (screenWidth >= COLOR_SWATCHES_BREAKPOINTS.DESKTOP_MIN) {
    return 'desktop';
  }
  if (screenWidth >= COLOR_SWATCHES_BREAKPOINTS.TABLET_MIN && screenWidth <= COLOR_SWATCHES_BREAKPOINTS.TABLET_MAX) {
    return 'tablet';
  }
  return 'mobile';
};

/**
 * @param {string} variantSwatchType
 * @param {Array} colorVariants
 * @param {string} deviceTypeFromAppCtx
 * @returns {boolean}
 */
export const shouldShowExpandable = (variantSwatchType, colorVariants, deviceTypeFromAppCtx) => {
  if (!variantSwatchType || !colorVariants) {
    return false;
  }
  let deviceType = deviceTypeFromAppCtx;
  if (!deviceType || deviceType === 'desktop') {
    const screenWidth = typeof window !== 'undefined' ? window.innerWidth : 1024;
    deviceType = getDeviceType(screenWidth);
  }

  const threshold = EXPANDABLE_THRESHOLDS[deviceType.toUpperCase()]?.[variantSwatchType];

  return threshold ? colorVariants.length >= threshold : false;
};
